import { isEmpty, isNull } from 'es-toolkit/compat';
import { isNilOrEmpty } from 'features/assets/assets.util';
import Papa from 'papaparse';
import type { RefObject } from 'react';
import type { CampaignDataRow } from '../campaigns-table.types';

type CbrTableRow = {
  'Marketplace/Language': string;
  'Product Line': string;
  'Journeys URL': string;
  'Creative Name': string;
  Owner: string;
  Platforms: string;
};
export const CSVDownloadUtil = ({
  projectId,
  data,
  shareRef,
}: {
  projectId: string;
  data: Array<CampaignDataRow>;
  shareRef: RefObject<HTMLAnchorElement>;
}) => {
  const parsedData: Array<CbrTableRow> = data.map((elem) => ({
    'Creative Name': elem.name ?? '(Untitled)',
    'Journeys URL': 'Not decided yet',
    'Marketplace/Language': elem.language.join(','),
    Owner: elem.createdBy,
    Platforms: elem.platform.join(','),
    'Product Line': elem.productLine,
  }));
  const csvOutput = generateCSV(parsedData);
  const csvUrl = createCsvUrl(csvOutput);
  if (!isNull(shareRef.current)) {
    shareRef.current!.href = csvUrl;
    // using `?` instead of `??`, because `??` allows the empty string (bad for file names)
    const fileName = isEmpty(projectId) ? projectId : 'Untitled_Journeys_Project';
    shareRef.current.download = `${fileName}.csv`;
    shareRef.current.click();
    if (!isNilOrEmpty(csvUrl)) {
      URL.revokeObjectURL(csvUrl);
    }
  } else {
    console.error('<Anchor /> element not rendered successfully, shareRef.current is NULL');
  }
};

const generateCSV = (parsedData: Array<CbrTableRow>): string => {
  try {
    return Papa.unparse(parsedData);
  } catch (err) {
    console.error('failed to tabulate form values and generate CSV', err);
    return 'failed to tabulate form values and generate CSV';
  }
};

const createCsvUrl = (csvOutput: string): string => {
  const csvFileBlob = new Blob(
    [
      csvOutput,
    ],
    {
      type: 'text/csv;charset=utf-8;',
    },
  );
  return URL.createObjectURL(csvFileBlob);
};
